import { useMemo } from 'react';
import { useContent } from 'views/rebranded-module/common/context/useContent';

export const useGetRegions = () => {
  const content = useContent('InteractiveMapComponent');

  const regions = useMemo(
    () => content.regions.map((region) => ({
      name: region.regionName,
      mapInfo: {
        desktop: {
          center: {
            lat: region.desktopCenterLat,
            lng: region.desktopCenterLng,
          },
          zoom: region.desktopZoom,
        },
        mobile: {
          center: {
            lat: region.mobileCenterLat,
            lng: region.mobileCenterLng,
          },
          zoom: region.mobileZoom,
        },
      },
    })),
    [],
  );
  return regions;
};
